import React from 'react';
import { T } from '../../utils/theme';
import { CheckCircle } from 'lucide-react';

const ConfirmationStep = ({ ticket, onFinish }) => {
  const position = ticket?.position || null;

  React.useEffect(() => {
    const timer = setTimeout(onFinish, 8000);
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div style={{
      minHeight: '100%', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: T.bg, padding: '40px 24px',
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: 40,
        background: 'rgba(48,209,88,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
      }}>
        <CheckCircle size={40} color={T.success} />
      </div>

      <div style={{ fontSize: 28, fontWeight: 700, color: T.label, textAlign: 'center', letterSpacing: '-0.025em' }}>
        Voce entrou na fila!
      </div>
      <div style={{ fontSize: 16, color: T.label2, textAlign: 'center', marginTop: 8 }}>
        Aguarde ser chamado pelo barbeiro
      </div>

      {position !== null && position !== undefined && (
        <div style={{
          background: '#fff', borderRadius: 20, padding: '24px 40px', marginTop: 28,
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)', textAlign: 'center',
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.label2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Sua posicao
          </div>
          <div className="tnum" style={{ fontSize: 56, fontWeight: 700, color: T.accent, marginTop: 4, lineHeight: 1 }}>
            {position}ª
          </div>
        </div>
      )}

      <button onClick={onFinish} style={{
        marginTop: 32, padding: '16px 40px', borderRadius: 16, border: 'none',
        background: T.accent, color: '#fff', fontFamily: 'inherit', fontSize: 17, fontWeight: 600, cursor: 'pointer',
        boxShadow: '0 4px 14px rgba(10,132,255,0.35)',
      }}>Finalizar</button>

      <div style={{ textAlign: 'center', padding: '32px 0 0', fontSize: 12, color: T.label3 }}>Feito por Barbx</div>
    </div>
  );
};

export default ConfirmationStep;
